export { default } from "./AnnotationText";
